import { noAuthInstance } from "hooks/useRequest/helper"
import { IApiRequest, IServerResponse } from "rules/interface/api/response"
import IUserVerifyBody from "rules/interface/user/verify-body.interface"
import IUserVerify from "rules/interface/user/verify.interface"
import { USERS_VERIFY_URL } from "./urls"




export const userVerify = async ({ data }: IApiRequest<IUserVerifyBody>): Promise<IServerResponse<IUserVerify>> => {
    return await noAuthInstance.post(USERS_VERIFY_URL, data)
        .then(res => res.data)
}